export const OWA_AUTO_LINKS_CLASSNAME = 'OWAAutoLink';
export const LINK_CONTEXT_MENU = 'LinkContextMenu';
